/** @format */
import { Heading } from '@mpb-com/feather/components/atoms/heading';
import { HeadingSize } from '@mpb-com/feather/components/atoms/heading/types';
import {
    Icon,
    IconSize,
    IconVariant,
} from '@mpb-com/feather/components/atoms/icon';
import React from 'react';
import styled from 'styled-components';

import Keyline from '@toucan/client/global/images/keyline.svg';

import { styles } from './product-trust-card.styles';
import { ProductTrustCardProps, StyledProductTrustCardProps } from './types';

export const StyledProductTrustCard = styled(
    'section'
)<StyledProductTrustCardProps>`
    ${styles}
`;

// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export const DEFAULT_TEST_ID = 'product-trust-card';

export const ProductTrustCard = ({
    heading,
    icon,
    'data-testid': dataTestId = DEFAULT_TEST_ID,
    variant,
    withKeyline = false,
    className = '',
    children,
    ...otherProps
}: ProductTrustCardProps) => {
    return (
        <StyledProductTrustCard
            data-testid={dataTestId}
            variant={variant}
            {...otherProps}
        >
            <div
                className={`product-trust-card-container ${className}`}
                data-testid={`${dataTestId}-container`}
            >
                {/* eslint-disable-next-line react/jsx-no-leaked-render -- Legacy code: do not use as an example. */}
                {withKeyline && <Keyline className="keyline" />}
                <Icon
                    size={IconSize.S}
                    variant={IconVariant.DECORATIVE}
                    data-testid={`${dataTestId}__icon`}
                    className={'product-trust-card-icon'}
                >
                    {icon}
                </Icon>

                <Heading
                    size={HeadingSize.H5}
                    className="title"
                    data-testid={`${dataTestId}__heading`}
                >
                    {heading}
                </Heading>
                <div
                    data-testid={`${dataTestId}__children`}
                    className="product-trust-card-children"
                >
                    {children}
                </div>
            </div>
        </StyledProductTrustCard>
    );
};
